import { Button, Space, Tag } from 'antd';
import {
  CheckOutlined,
  CloseOutlined,
  CopyOutlined,
  EditOutlined,
  ReloadOutlined
} from '@ant-design/icons';
import type { PolicyExportType } from './api';
import type { LeadPolicyDocument } from './types';

type PolicyAnalysisActionsProps = {
  doc: LeadPolicyDocument;
  isEditing: boolean;
  policyAnalyzeAllBackground: boolean;
  policyCopyCreating: boolean;
  policySaving: boolean;
  policyReanalyzing: boolean;
  onCreateCopy: (doc: LeadPolicyDocument) => void;
  onStartEdit: (doc: LeadPolicyDocument) => void;
  onSaveEdit: (doc: LeadPolicyDocument) => void;
  onCancelEdit: (policyId: string) => void;
  onPdfExport: (doc: LeadPolicyDocument, type: PolicyExportType) => void;
  onReanalyze: (doc: LeadPolicyDocument) => void;
};

export default function PolicyAnalysisActions({
  doc,
  isEditing,
  policyAnalyzeAllBackground,
  policyCopyCreating,
  policySaving,
  policyReanalyzing,
  onCreateCopy,
  onStartEdit,
  onSaveEdit,
  onCancelEdit,
  onPdfExport,
  onReanalyze
}: PolicyAnalysisActionsProps) {
  return (
    <Space size={8} wrap>
      {!doc.analysis_edit && !isEditing ? (
        <Button
          size="small"
          icon={<CopyOutlined />}
          onClick={() => onCreateCopy(doc)}
          loading={policyCopyCreating}
          disabled={doc.analysis_status !== 'COMPLETED'}
        >
          Opret redigerbar kopi
        </Button>
      ) : null}
      {doc.analysis_edit && !isEditing ? (
        <Button size="small" icon={<EditOutlined />} onClick={() => onStartEdit(doc)}>
          Redigér kopi
        </Button>
      ) : null}
      {isEditing ? (
        <>
          <Button
            size="small"
            type="primary"
            icon={<CheckOutlined />}
            onClick={() => onSaveEdit(doc)}
            loading={policySaving}
          >
            Gem kopi
          </Button>
          <Button size="small" icon={<CloseOutlined />} onClick={() => onCancelEdit(doc.id)}>
            Annuller
          </Button>
        </>
      ) : null}
      <Button
        size="small"
        onClick={() => onPdfExport(doc, 'tender')}
        disabled={doc.analysis_status !== 'COMPLETED'}
      >
        Udbudsmateriale (PDF)
      </Button>
      <Button
        size="small"
        icon={<ReloadOutlined />}
        loading={policyReanalyzing}
        onClick={() => onReanalyze(doc)}
        disabled={policyReanalyzing || (policyAnalyzeAllBackground && doc.analysis_status === 'PENDING')}
      >
        {doc.analysis_status === 'COMPLETED' ? 'Ny AI-analyse' : 'Analyser police'}
      </Button>
      <Button
        size="small"
        onClick={() => onPdfExport(doc, 'customer-agreement')}
        disabled={doc.analysis_status !== 'COMPLETED'}
      >
        Aftaledokument (PDF)
      </Button>
      {doc.analysis_edit ? <Tag color="processing">Redigerbar kopi aktiv</Tag> : null}
    </Space>
  );
}
